var _ = require('underscore');
var Section = require('front/pages/Section/Section');

require('./Benefits.less');

module.exports = Section.extend({

    el: '.Benefits',

    initialize: function (options) {
        this.options = options || {};

        Section.prototype.initialize.call(this, options);
    }
});


//////////////////
// WEBPACK FOOTER
// ./assets/app/front/pages/Benefits/Benefits.js
// module id = 260
// module chunks = 0